import { Link, useNavigate, useParams } from "react-router-dom";

import { Button, Card } from "../ui";
import { homePath } from "./access";
import { useCurrentMe } from "./auth";
import { MODULE_NAMES, type Screen } from "./screens";
import { useDocumentTitle } from "./title";

/** The page shown for a screen that its module has not built yet. */
export function Placeholder({ screen }: { screen: Screen }) {
  const params = useParams();
  const shown = Object.entries(params).filter(([key]) => key !== "*");
  return (
    <Card className="placeholder" aria-labelledby="screen-title">
      <h1 id="screen-title">{screen.title}</h1>
      <p>{screen.summary}</p>
      <p className="muted">This screen is not built yet.</p>
      <dl>
        <dt>Address</dt>
        <dd>
          <code>{screen.path}</code>
        </dd>
        {shown.map(([key, value]) => (
          <div key={key} style={{ display: "contents" }}>
            <dt>{key}</dt>
            <dd>
              <code>{value}</code>
            </dd>
          </div>
        ))}
        <dt>Built by</dt>
        <dd>
          {screen.module}, {MODULE_NAMES[screen.module]}
        </dd>
        {screen.reads.length > 0 && (
          <>
            <dt>Reads</dt>
            <dd>{screen.reads.join(", ")}</dd>
          </>
        )}
        {screen.sends.length > 0 && (
          <>
            <dt>Sends</dt>
            <dd>{screen.sends.join(", ")}</dd>
          </>
        )}
      </dl>
    </Card>
  );
}

/** There is no screen at the address: say so, name the tab, and give two ways out (UI-26). */
export function NotFound() {
  const me = useCurrentMe();
  const navigate = useNavigate();
  useDocumentTitle("Page not found");
  return (
    <Card aria-labelledby="not-found-title">
      <h1 id="not-found-title">Page not found</h1>
      <p>There is no screen at this address.</p>
      <div className="row">
        <Link className="button button--primary" to={homePath(me)}>
          Go to the home screen
        </Link>
        <Button onClick={() => void navigate(-1)}>Go back</Button>
      </div>
    </Card>
  );
}
